import axios from "axios";

const baseUrl = `${process.env.REACT_APP_GITO_API_URL}/tariffs/tariff`;
//const baseUrl = "https://localhost:7241/Tariff";
  
  // Function to get a specific charging connector by chargingConnectorPublicId
  export async function getTariffByPublicId(tariffPublicId, apiAccessToken) {
    try {
      const response = await axios.get(
        `${baseUrl}/get-tariff-by-public-id/${tariffPublicId}`,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${apiAccessToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.detail || "Failed to fetch tariff"
      );
    }
  }

export async function getCompleteTariff(tariffPublicId, apiAccessToken) {
  try {
    const response = await axios.get(
      `${baseUrl}/get-tariff/${tariffPublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to fetch complete tariff"
    );
  }
}

export async function getTariffs(apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/get-tariffs`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiAccessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || "Failed to fetch tariffs");
  }
}

export async function getSimpleTariffsByOperatorOrganizationPublicId(
  organizationPublicId,
  apiAccessToken
) {
  try {
    const response = await axios.get(
      `${baseUrl}/get-simple-tariffs-by-operator-organization-public-id/${organizationPublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || "Failed to fetch tariffs");
  }
}

export async function getAllTariffs(apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/get-simple-tariffs`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiAccessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || "Failed to fetch tariffs");
  }
}

export async function getTariffList(apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/get-tariff-list`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiAccessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || "Failed to fetch tariffs");
  }
}

export async function deleteTariff(tariffPublicId, apiAccessToken) {
  try {
    await axios.delete(`${baseUrl}/delete-tariff/${tariffPublicId}`, {
      headers: {
        Authorization: `Bearer ${apiAccessToken}`,
      },
    });
  } catch (error) {
    throw new Error(error.response?.data?.detail || "Failed to delete tariff");
  }
}

export async function createTariff(tariff, apiAccessToken) {
  try {
    const response = await axios.post(
      `${baseUrl}/create-tariff-v3`,
      tariff,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.detail || "Failed to create tariff");
  }
}

export async function createTariffWithAltTextAndConnectors(tariff, apiAccessToken) {
  try {
    const response = await axios.post(
      `${baseUrl}/create-tariff-with-alt-text-and-connectors`,
      tariff,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || "Failed to create tariff");
  }
}

export async function updateTariff(tariffData, apiAccessToken) {
  try {
    const response = await axios.put(`${baseUrl}/update-tariff-v3`, tariffData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiAccessToken}`,
      },
    });

    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || "Failed to update tariff");
  }
}

export async function updateTariffElement(elementData, apiAccessToken) {
  try {
    const response = await axios.put(`${baseUrl}/update-elements`, elementData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiAccessToken}`,
      },
    });

    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || "Failed to update elements");
  }
}

export async function assignTariffToConnector(connectorData, apiAccessToken) {
  try {
    const response = await axios.post(
      `${baseUrl}/assign-tariff-to-connectors/`,
      connectorData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || "Failed to update tariff");
  }
}

export async function addConnectorsToTariff(
  { tariffPublicId, connectorPublicIds },
  apiAccessToken
) {
  try {
    const response = await axios.put(
        `${baseUrl}/connectors/`,
      {
        tariffPublicId,
        connectorPublicIds,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to add connectors to tariff"
    );
  }
}

export async function createTariffElementWithComponents(dto, tariffPublicId, apiAccessToken) {
  try {
    const response = await axios.post(
      `${baseUrl}/create-tariff-element-with-components/${tariffPublicId}`,
      dto,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to add element to tariff"
    );
  }
}

/* export async function deleteElementFromTariff(
  tariffElementPublicId,
  apiAccessToken
) {
  try {
    const response = await axios.delete(
      `${baseUrl}/delete-element-from-tariff/${tariffElementPublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to delete element from tariff"
    );
  }
} */

export async function deleteConnectorFromTariff(tariffPublicId, connectorPublicId, apiAccessToken) {
  try {
    const response = await axios.delete(
      `${baseUrl}/remove-connector-from-tariff/`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
        data: {
          tariffPublicId,
          connectorPublicId,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to delete connector from tariff"
    );
  }
}

export async function previewTariffAssignmentConflicts(payload, apiAccessToken) {
  try {
    const response = await axios.post(
      `${baseUrl}/preview-assignment-conflicts`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to preview tariff assignment conflicts"
    );
  }
}

export async function getCustomerTariffs(customerPublicID, apiAccessToken) {
    try {
        const response = await axios.get(
            `${baseUrl}/get-customer-tariffs/${customerPublicID}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to fetch complete tariff"
        );
    }
}

